import Vue from "vue";
import Moment from "moment";
import VuemomentJS from "vue-momentjs";

const state = {
  orders: [],
  order: {},
  totalOrders: 0,
  orderStatuses: []
};

const getters = {};

const actions = {
  LOAD_ORDERS: async function({ commit, rootState }, payload) {
    
    let orderNumberQuery = payload.orderNumber
      ? "&orderNumber=" + payload.orderNumber
      : "";
    return await Vue.prototype.$axios
      .get(
        "suppliers/"+rootState.auth.user.usupplier+"/orders?from=" +
          payload.from +
          "&limit=" +
          payload.to +
          orderNumberQuery
      )
      .then(
        response => {
          commit("SET_ORDERS", response.data.supplierOrders);
          commit("SET_TOTAL_ORDERS", response.data.meta.total);
          return response;
        },
        err => {
          throw new Error(err);
        }
      );
  },
  LOAD_ORDER: async function({ commit, rootState }, payload) {
    return await Vue.prototype.$axios.get("suppliers/"+rootState.auth.user.usupplier+"/orders/" + payload).then(
      response => {
        commit("SET_ORDER", response.data.order);
      },
      err => {
        throw new Error(err);
      }
    );
  },
  LOAD_ORDER_STATUSES: async function({ commit }, payload) {
    return await Vue.prototype.$axios
      .get("/orders/statuses", payload)
      .then(
        res => {
          commit("SET_ORDER_STATUSES", res.data.orderStatuses)
        }
      )
  },
  DESTROY_ORDER: async function({ commit, rootState }, payload) {
    return await Vue.prototype.$axios.delete("suppliers/"+rootState.auth.user.usupplier+"/orders/" + payload);
  },
};

const mutations = {
  SET_ORDERS: (state, orders) => {
    state.orders = orders;
  },
  SET_ORDER: (state, order) => {
    state.order = order;
  },
  SET_TOTAL_ORDERS: (state, total) => {
    state.totalOrders = total;
  },
  SET_ORDER_STATUSES: (state, payload) => {
    state.orderStatuses = payload
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
